export default __webpack_public_path__ + "static/media/iron-man.5c040492.png";